import axiosInstance from '../axiosConfig';

export interface Job {
    id: number;
    title: string;
    organization: string;
    location: string;
    type: string;
    type_label: string;
    close_date: string;
    department: string | null;
    salary: number | null;
    formatted_salary: string;
    vacancy_number: string | null;
    gender: string;
    gender_label: string;
    no_of_jobs: number;
    description: string | null;
    contact_email: string | null;
    is_active: boolean;
    order: number;
    created_at: string;
}

export interface JobsResponse {
    success: boolean;
    data: Job[];
    message: string;
    count: number;
    meta?: {
        total: number;
        per_page: number;
        current_page: number;
        last_page: number;
    };
}

export const jobService = {
    async getAll(params?: { page?: number; per_page?: number; search?: string }): Promise<JobsResponse> {
        try {
            const response = await axiosInstance.get('/api/admin/jobs', { params });
            return response.data;
        } catch (error) {
            console.error('Error in getAll:', error);
            throw error;
        }
    },

    async getById(id: number): Promise<{ success: boolean; data: Job }> {
        try {
            const response = await axiosInstance.get(`/api/admin/jobs/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getById:', error);
            throw error;
        }
    },

        async create(data: any): Promise<{ success: boolean; data: Job }> {
            try {
                console.log('Creating job with data:', data);
                const response = await axiosInstance.post('/api/admin/jobs', data);
                return response.data;
            } catch (error: any) {
                console.error('Error in create:', error);
                console.error('Response data:', error.response?.data);
                throw error;
            }
        },

        async update(id: number, data: any): Promise<{ success: boolean; data: Job }> {
            try {
                console.log('Updating job with data:', data);
                const response = await axiosInstance.put(`/api/admin/jobs/${id}`, data);
                return response.data;
            } catch (error: any) {
                console.error('Error in update:', error);
                console.error('Response data:', error.response?.data);
                throw error;
            }
        },

    

    async delete(id: number): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.delete(`/api/admin/jobs/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in delete:', error);
            throw error;
        }
    },

    async bulkDelete(ids: number[]): Promise<{ success: boolean; message: string; deleted_count?: number }> {
        try {
            const response = await axiosInstance.post('/api/admin/jobs/bulk-delete', { ids });
            return response.data;
        } catch (error) {
            console.error('Error in bulkDelete:', error);
            throw error;
        }
    },

    async updateStatus(id: number, isActive: boolean): Promise<{ success: boolean; message: string; data: any }> {
        try {
            const response = await axiosInstance.patch(`/api/admin/jobs/${id}/status`, { is_active: isActive });
            return response.data;
        } catch (error) {
            console.error('Error in updateStatus:', error);
            throw error;
        }
    },

    async reorder(orders: { id: number; order: number }[]): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.post('/api/admin/jobs/reorder', { orders });
            return response.data;
        } catch (error) {
            console.error('Error in reorder:', error);
            throw error;
        }
    }
};